"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _styles = require("./styles");
const ButtonList = _ref => {
  let {
    id,
    options,
    onAnswer,
    answer,
    ariaDescribedby
  } = _ref;
  const [currentAnswer = ''] = answer || [];
  return /*#__PURE__*/_react.default.createElement(_styles.RadioButton, {
    name: `gx-question-${id}`,
    options: (0, _filter.default)(options).call(options, _ref2 => {
      let {
        label,
        value
      } = _ref2;
      return value && label;
    }),
    selected: currentAnswer,
    mode: "buttons",
    buttonStyle: "primary",
    row: true,
    onChange: (_event, value) => onAnswer([value]),
    "aria-describedby": ariaDescribedby
  });
};
ButtonList.propTypes = {
  // list of buttons to display
  options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    value: _propTypes.string,
    label: _propTypes.string
  })).isRequired,
  // callback when the input is answered, accepts an array containing the selected value
  onAnswer: _propTypes.func.isRequired,
  // if an answer is provided, it's passed down in an array
  answer: (0, _propTypes.arrayOf)(_propTypes.string),
  id: _propTypes.string.isRequired,
  ariaDescribedby: _propTypes.string.isRequired
};
var _default = exports.default = ButtonList;
ButtonList.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ButtonList",
  "props": {
    "options": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "value": {
              "name": "string",
              "required": false
            },
            "label": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": true
    },
    "onAnswer": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "answer": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false
    },
    "id": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "ariaDescribedby": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};